"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGIN_VERSION = void 0;
// This file is auto-generated during the release process.
// Do not edit manually.
exports.PLUGIN_VERSION = "9.7.0";
//# sourceMappingURL=version.js.map